<template>
    <Button :label="$t('messages.download')" :icon="downloading ? 'pi pi-spin pi-spinner' : 'pi pi-arrow-down'" iconPos="right"
        class="boton-descarga" @click="descargarpdfconid" :disabled="downloading" v-if="size === 'normal'" />
    <Button :icon="downloading ? 'pi pi-spin pi-spinner' : 'pi pi-arrow-down'"
        class="p-button-rounded p-button-info p-mr-2" @click="descargarpdfconid" v-tooltip.top="$t('messages.download')"
        name="descargar" :disabled="downloading" v-else />
</template>

<script>
import CotizacionesService from "../service/cotizaciones.service";
export default {
    name: 'BotonDescargaCotizacion',
    data() {
        return {
            cotizacionesService: new CotizacionesService(),
            downloading: false
        };
    },
    props: {
        id: {
            type: Number,
            required: true
        },
        size: {
            type: String,
            default: 'normal'
        }
    },
    methods: {
        descargarpdfconid() {
            this.downloading = true;
            this.cotizacionesService
                .downloadCotizacionConId(this.id,this.$i18n.locale)
                .then((response) => {
                    const contentDisposition = response.headers["content-disposition"];
                    let fileName = contentDisposition ? contentDisposition.split(";")[1].split("=")[1] : "descarga.pdf";
                    fileName = fileName.replace(/"/g, "");
                    this.downloading = false;
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(() => {
                    this.downloading = false;
                    this.$toast.add({
                        severity: "error",
                        summary: "Error en descarga",
                        detail: "Error al tratar de descargar cotización",
                        life: 3000,
                    });
                });
        }
    }
}
</script>
